import {Component, OnInit, ChangeDetectionStrategy, ViewChild, ElementRef, ChangeDetectorRef, AfterViewInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {BsModalEventsEmitter} from 'src/app/modules/shared/events/bsModal.events';
import {Subscription} from 'rxjs';
import {DiaryService} from 'src/app/modules/shared/services/diary.service';
import {filter} from 'rxjs/operators';
import {LocalisationService} from 'src/app/modules/shared/services/localisation.service';
import {ExternalMealViewModel} from '../../viewModels/externalMeal.viewModel';
import {MealsComponent} from '../../meals/meals.component';
import {AppLoadingEventsEmitter} from '../../../../shared/events/loading.events';
import {ProductsService} from '../../../../shared/services/products.service';
import {ProductViewModel} from '../../../../shared/viewModels/product.viewModel';
import {ExternalMealsComponent} from './external-meals.component';

@Component({
    selector: 'app-weight-qty',
    templateUrl: './weight-qty.component.html',
    styleUrls: ['./weight-qty.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default
})
export class WeightQtyComponent implements OnInit, AfterViewInit {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;

    externalMealsComponent: ExternalMealsComponent;
    index: number;
    externalMeal: ExternalMealViewModel = {
        'title': '',
        'by': 'WEIGHT',
        'qty': 1,
        'weight': 100
    };

    constructor(
        public readonly bsModalRef: BsModalRef,
        private readonly changeDetectorRef: ChangeDetectorRef,
    ) {
    }

    ngOnInit() {
        this.toBigger();
    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    }

    save() {
        if (this.externalMeal.by === 'WEIGHT') {
            this.externalMealsComponent.changeMealWeight(this.externalMeal.weight, this.index);
        } else {
            this.externalMealsComponent.changeMealQty(this.externalMeal.qty, this.index);
        }

        this.bsModalRef.hide();
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

    private toBigger() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;

        modalDialog.style.minWidth = '50%';
    }

    isIOS() {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    }
}
